export default class AttachmentModel {
  constructor() {
    // ID
    this.caseId = '';
    this.file_index = 0;
    // 編碼
    this.file_body_encode = '';
    this.file_size = '';
    // 類型
    this.content_type = '';
    this.name = '';
    this.file_body_full = '';
  }
}



// WEBPACK FOOTER //
// ./src/models/AttachmentModel.js